import { useSyncExternalStore } from 'react'

const useIsScrolled = () => {
  return useSyncExternalStore(
    callback => {
      window.addEventListener('scroll', callback)
      return () => window.removeEventListener('scroll', callback)
    },
    () => window.scrollY > 0,
    () => false
  )
}

export { useIsScrolled }
